import React, { PureComponent } from 'react'
import UpdatePasswordFormContainer from '../components/updatePassword/UpdatePasswordFormContainer'

export default class UpdatePassword extends PureComponent {

  render() {
    return (
      <div className='page-wrapper login-page forgot-password'>
        <div className='block image-box'>
          <div className='background-image' />
          <div className='background-title'>
            <div className='background-highlight'>
              Hi!
            </div>
            <div className='background-highlight full-width'>
              Welcome Back
            </div>
          </div>
        </div>
        <div className='block content-wrapper'>
          <div>
            <UpdatePasswordFormContainer />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/UpdatePassword.js